<template>
  <div>
    <p class="title" :class="{'has-text-white': white}">User details</p>
    <p class="help is-danger" v-if="error">{{error}}</p>
    <p :class="{'has-text-white': white}"><b>Name:</b> {{user.name}} </p>
    <p :class="{'has-text-white': white}"><b>Email:</b> {{user.email}} </p>
    <p>
      <b :class="{'has-text-white': white}">Trackers:</b>
      <table v-if="user.trackers.length > 0" class="table is-size-6 is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th :class="{'has-text-white': white}"><abbr title="Identifier of the tracker">ID</abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr
          v-for="id in user.trackers"
          :key="id">
            <th :class="{'has-text-white': white}">{{id}}</th>
          </tr>
        </tbody>
      </table>
      <span :class="{'has-text-white': white}" v-else>No trackers added yet</span>
    </p>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      error: null
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    async addTracker () {
      this.loading = true
      this.error = null
      const result = await this.$store.dispatch('addTracker', this.id)
      this.loading = false
      if (result.error) this.error = result.message
    }
  },
  async created () {
    this.error = await this.$store.dispatch('getUser')
  }
}
</script>

<style scoped>
.button {
  margin-top: 1em;
}
</style>
